import axios from 'axios'
import Cookies from 'js-cookie';

import { BASEURL } from '@/utils/url'

const request = axios.create({
    baseURL: BASEURL,    //基础路径
    timeout: 600000,  //请求超时
})
// var ticket = ''
//请求拦截器
request.interceptors.request.use(config => {
    const ticket = Cookies.get('ticket')
    if (ticket) {
        config.headers['X-Token'] = ticket      // ✅ 加在这里
    }

    //请求拦截
    return config
}, error => {
    return Promise.reject(error)
})



//响应拦截器
request.interceptors.response.use(response => {
    return response
}, error => {

    return Promise.reject(error)
})

export default request   //导出自定义axios对象
// import axios from 'axios'
// import Cookies from 'js-cookie';
// import { BASEURL } from '@/utils/url'
// // 引入统一的清理登录态函数
// import { clearLoginState } from '@/utils/auth.js'; 
// import { Message } from 'element-ui'; // 假设你用了element-ui的Message

// const request = axios.create({
//     baseURL: BASEURL,
//     timeout: 600000,
// })

// // 请求拦截器
// request.interceptors.request.use(config => {
//     const ticket = Cookies.get('ticket')
//     if (ticket) {
//         config.headers['X-Token'] = ticket;
//     }
//     return config
// }, error => {
//     return Promise.reject(error)
// })

// // 响应拦截器
// request.interceptors.response.use(response => {
//     return response
// }, error => {
//     // 处理 token 过期（后端通常返回401状态码）
//     if (error.response && error.response.status === 401) {
//         Message.warning('登录态已过期，请重新登录');
//         // 自动清理登录态
//         clearLoginState();
//         // 跳转到登录页（避免重复跳转）
//         const currentPath = window.location.hash.slice(1);
//         if (currentPath !== '/User/Login') {
//             window.location.href = '#/User/Login';
//         }
//     }
//     return Promise.reject(error)
// })

// export default request;